/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EpoDnepduosDo } from './epoDnepduosDo.model';


export interface NonCadastralContractParcelDataDto { 
    acquisitionTax?: number;
    acquisitionTaxAdd?: number;
    buyPrice?: number;
    contractId?: number;
    dnepduos1?: EpoDnepduosDo;
    dnepduos1Acreage?: number;
    dnepduos1Year?: number;
    dnepduos2?: EpoDnepduosDo;
    dnepduos2Acreage?: number;
    dnepduos2Year?: number;
    dnepduos3?: EpoDnepduosDo;
    dnepduos3Acreage?: number;
    dnepduos3Year?: number;
    drupozKodMan?: number;
    koeficientMan?: number;
    osvobozenaVymera?: number;
    parcelId?: number;
    parcelRentAveragePrice?: number;
    parcelRentFromAcreage?: number;
    parcelRentParcelPrice?: number;
    priceAddAveragePrice?: number;
    priceAddAveragePricePercent?: number;
    priceAddParcelPrice?: number;
    priceAddParcelPricePercent?: number;
    pronajataVymera: number;
    pronajataVymeraAuto?: string;
    pronajataVymeraVolba?: string;
    pronajataVymeraZdroj?: string;
    realEstateBrokerage?: number;
    taxAdd?: number;
    taxComputed?: number;
    taxFromRentedAcreage?: number;
    taxPayerId?: number;
    taxTenant?: boolean;
    useParcelRent?: boolean;
    useTaxFromRentedAcreage?: boolean;
    useTaxReturnDrupozKodOriginal?: boolean;
    zastavenaVymera?: number;
    zpevnenaPlochaX?: number;
    zpevnenaPlochaY?: number;
    zpvypoKodMan?: number;
}

